<template>
    <div class="card">
      <div class="card-body pb-0 pt-2">
        <ul class="nav nav-tabs nav-tabs-bottom">
          <!-- <li class="nav-item me-3">
            <router-link
              v-bind:class="{
                'nav-link px-0': true,
                active:
                  currentPath.includes('basic-info') 
              }"
              to="/leads-individual/initial-info"
            >
              <i class="ti ti-settings-cog me-2"></i> Individual
            </router-link>
          </li> -->
          <li class="nav-item me-3">
            <router-link
              v-bind:class="{
                'nav-link px-0': true,
                active:
                  currentPath.includes('concern-person-info')
              }"
              to="/leads-organization/initial-info"
            >
              <i class="ti ti-world-cog me-2"></i> Organization
            </router-link>
          </li>
  
        </ul>
      </div>
    </div>
  </template>
  <script>
  export default {
    data() {
      return {
        currentPath: this.$route.path,
      };
    },
  };
  </script>
  